import { MRT_ColumnDef } from "material-react-table"
import {
  PNLConfig,
  PNLConfigDisabled,
  bottomFooterCellStyles,
  disableColBodyStyles,
  disableColHeadStyles,
  footerCellStyles,
  headerStyles,
  topFooterCellStyles,
} from "./pnlTableConfig"
import { condenseNumber } from "../ResourceBudgetTable/validators"
import { strFormat } from "../ResourceBudgetTable/utils"
import { Box, Typography } from "@mui/material"
import { colors } from "../../../../styles/commonStyles"

const CELLWIDTH = 150

const editable = (
  row: any,
  resourceBudgetPublished: boolean,
  selectedClass?: string,
) => {
  console.log(row,'row==>')
  // return true;
  // if( selectedClass === "PSC"){
  //   return true;
  // }
  const disabledRows = [
    "DOCTOR COMPENSATION",
    "HYGIENE COMPENSATION",
    "FRONT DESK COMPENSATION",
    "DENTAL ASSISTANT COMPENSATION",
  ]

  console.log(selectedClass,'CLASS LABEL')

  // Always disable these 4 compensation rows regardless of resourceBudgetPublished status
  if (
    disabledRows.includes(row.original?.line_item) &&
    selectedClass !== "PSC"
  ) {
    return false
  }

  // Header row (index 0) is not editable
  // if (row.index === 0) {
  //   return false
  // }

  // return resourceBudgetPublished ? row.index !='0' : true
  return true;
}

export const GenerateCols = (
  budgetYear: number,
  budgetData: any,
  aggregations: any,
  meta: any,
  resourceBudgetPublished: boolean,
  dirtyCells: any,
  selectedClass?: string,
) => {
  const PNLConfigurations = PNLConfigDisabled
  // resourceBudgetPublished
  //   ? PNLConfigDisabled
  // : PNLConfig

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ]
  const cellStyles = {
    height: "48px",
    justifyContent: "center",
    border: "0.5px solid #E4E4E4",
    boxShadow: " #00000022 1.95px  0px 2.6px",
  }
  const revenue = budgetData[0]
  const colsOrder: string[] = []
  let hasRevenueNotSet = false

  let dynamicCols: MRT_ColumnDef<any>[] = months?.map(
    (month: string, index: number) => {
      const monthIndex = index + 1
      const amountKey = `${monthIndex}_amount`
      const percentKey = `${monthIndex}_percent`
      const currentRevenue = revenue?.[amountKey]

      if (currentRevenue) {
        colsOrder.concat([amountKey, percentKey])
      } else {
        colsOrder.push(`disabled_${amountKey}`)
        hasRevenueNotSet = true
      }
      // return currentRevenue
      //   ?
      return {
        header: `${month} ${budgetYear}`,
        id: `${index + 1}`,

        columns: [
          {
            header: "$",
            id: amountKey,
            accessorKey: amountKey,
            muiTableHeadCellProps: {
              sx: { ...headerStyles },
            },

            muiTableBodyCellProps: ({ row, cell }: any) => {
              return {
                sx: {
                  ...cellStyles,
                  borderColor: dirtyCells.find(
                    (dirtyCell: any) =>
                      dirtyCell == cell.id.replace("percent", "amount"),
                  )
                    ? colors.primaryRed
                    : "#E4E4E4",
                  backgroundColor: editable(
                    row,
                    resourceBudgetPublished,
                    selectedClass,
                  )
                    ? colors.primaryWhite
                    : colors.grey50,
                  fontWeight: row.index ? "regular" : "bold",
                },
              }
            },
            muiTableFooterCellProps: {
              sx: { ...footerCellStyles },
            },
            size: CELLWIDTH,
            Footer: () => {
              return (
                <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                  <Box sx={{ ...topFooterCellStyles }}>
                    ${" "}
                    {parseInt(
                      aggregations[0]?.[amountKey] || "0",
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 0,
                    })}
                  </Box>
                  <Box sx={{ ...bottomFooterCellStyles }}>
                    ${" "}
                    {parseInt(
                      aggregations[1]?.[amountKey] || "0",
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 0,
                    })}
                  </Box>
                </Box>
              )
            },

            enableEditing: (row) =>
              editable(row, resourceBudgetPublished, selectedClass),
            Cell: ({ renderedCellValue }: any) =>
              `$ ${parseInt(renderedCellValue as string).toLocaleString(
                undefined,
                { minimumFractionDigits: 0 },
              )}` || "$ 0",
          },
          {
            header: "%",
            id: percentKey,
            accessorKey: percentKey,
            muiTableHeadCellProps: {
              sx: { ...headerStyles },
            },
            muiTableBodyCellProps: ({ row, cell }: any) => {
              return {
                sx: {
                  ...cellStyles,
                  borderColor: dirtyCells.find(
                    (dirtyCell: any) =>
                      dirtyCell == cell.id.replace("percent", "amount"),
                  )
                    ? colors.primaryRed
                    : "#E4E4E4",
                  backgroundColor:
                    row?.original?.line_item == "REVENUE"
                      ? colors.grey50
                      : editable(row, resourceBudgetPublished, selectedClass)
                        ? colors.primaryWhite
                        : colors.grey50,
                },
              }
            },
            muiTableFooterCellProps: {
              sx: { ...footerCellStyles },
            },

            size: CELLWIDTH,
            Footer: () => {
              return (
                <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                  <Box sx={{ ...topFooterCellStyles }}>
                    {aggregations[0]?.[percentKey] || "0"} %
                  </Box>
                  <Box sx={{ ...bottomFooterCellStyles }}>
                    {aggregations[1]?.[percentKey] || "0"} %
                  </Box>
                </Box>
              )
            },
            enableEditing: (row) =>
              editable(row, resourceBudgetPublished, selectedClass),
            Cell: ({ renderedCellValue, row }: any) =>
              row.index > 0
                ? `${parseFloat(renderedCellValue as string).toFixed(1)} %` ||
                "0 %"
                : "",
          },
        ],
      } as MRT_ColumnDef<any>
    },
    [resourceBudgetPublished, dirtyCells],
  )

  // Current year aggregations

  if (PNLConfigurations?.[2]?.columns?.[0]) {
    PNLConfigurations[2].header = `${budgetYear}` || "N\\A"
    PNLConfigurations[2].columns[0].Footer = () => {
      return (
        <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
          <Box sx={{ ...topFooterCellStyles }}>
            ${" "}
            {parseInt(
              aggregations[0]?.["-total_current"] || "0",
            ).toLocaleString(undefined, {
              minimumFractionDigits: 0,
            })}
          </Box>
          <Box sx={{ ...bottomFooterCellStyles }}>
            ${" "}
            {parseInt(
              aggregations[1]?.["-total_current"] || "0",
            ).toLocaleString(undefined, {
              minimumFractionDigits: 0,
            })}
          </Box>
        </Box>
      )
    }
    // Add footer for percentage column
    if (PNLConfigurations[2].columns[1]) {
      PNLConfigurations[2].columns[1].Footer = () => {
        return (
          <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <Box sx={{ ...topFooterCellStyles }}>
              {parseFloat(
                aggregations[0]?.["-total_current_percent"] || "0",
              ).toFixed(1)}{" "}
              %
            </Box>
            <Box sx={{ ...bottomFooterCellStyles }}>
              {parseFloat(
                aggregations[1]?.["-total_current_percent"] || "0",
              ).toFixed(1)}{" "}
              %
            </Box>
          </Box>
        )
      }
    }
  }

  // Previous year aggregations
  const annualCols = PNLConfigurations?.[1]?.columns || []
  if (PNLConfigurations?.[1].header) {
    PNLConfigurations[1].header = `${meta?.startMonth || "Jan"} to ${meta?.endMonth || "Dec"
      } ${budgetYear - 1}`
  }
  annualCols.forEach((col, index) => {
    annualCols[index].Footer = () => {
      return (
        <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
          <Box sx={{ ...topFooterCellStyles }}>
            {index !== 1 && "$ "}
            {parseFloat(
              aggregations[0]?.[col.accessorKey as string] || "0",
            ).toLocaleString(undefined, {
              maximumFractionDigits: index !== 1 ? 0 : 1,
            })}
            {index === 1 && " %"}
          </Box>
          <Box sx={{ ...bottomFooterCellStyles }}>
            {index !== 1 && "$ "}
            {parseFloat(
              aggregations[1]?.[col.accessorKey as string] || "0",
            ).toLocaleString(undefined, {
              maximumFractionDigits: index !== 1 ? 0 : 1,
            })}
            {index === 1 && " %"}
          </Box>
        </Box>
      )
    }
  })

  return {
    dynamicCols: PNLConfigurations.concat(dynamicCols),
    colsOrder,
    hasRevenueNotSet,
  }
}

export const TransformData = (data: any) => {
  let transformedObj: any = {}
  let footer: any = { exp: {}, net: {} }
  let configObj: {
    transformedData: any[]
    aggregation: any[]
    headers: {
      startMonth: string
      endMonth: string
    }
  } = {
    transformedData: [],
    aggregation: [],
    headers: {
      startMonth: "Dec",
      endMonth: "Jan",
    },
  }
  if (data?.monthly_budget_list) {
    Object.keys(data?.monthly_budget_list)?.forEach(
      (monthKey: string, index: number) => {
        const monthIndex = index + 1
        let expAmountTotal = 0
        let netAmountTotal = parseInt(
          data?.monthly_budget_list[monthKey][0].budget_amount,
        )
        let expPercentTotal = 0
        let netPercentTotal = 100

        data?.monthly_budget_list[monthKey].forEach((item: any) => {
          const lineItem = item.line_item
          if (!transformedObj[lineItem]) {
            transformedObj[lineItem] = {}
          }
          transformedObj[lineItem][`${monthIndex}_amount`] =
            condenseNumber(item.budget_amount) || 0
          const percentValue = parseFloat(item.budget_percentage)
          transformedObj[lineItem][`${monthIndex}_percent`] = Number.isNaN(
            percentValue,
          )
            ? 0
            : parseFloat(percentValue.toFixed(1))
          if (lineItem !== "REVENUE") {
            expAmountTotal = expAmountTotal + item.budget_amount
            netAmountTotal = netAmountTotal - item.budget_amount
            expPercentTotal = expPercentTotal + item.budget_percentage
            netPercentTotal = netPercentTotal - item.budget_percentage
          }
        })
        footer["exp"][`${monthIndex}_percent`] = expPercentTotal.toFixed(1)
        footer["exp"][`${monthIndex}_amount`] = expAmountTotal.toFixed(0)
        footer["net"][`${monthIndex}_percent`] = netPercentTotal.toFixed(1)
        footer["net"][`${monthIndex}_amount`] = netAmountTotal.toFixed(0)
      },
    )

    let currentTotalExpenses = 0
    const revenueTotal = transformedObj["REVENUE"]
      ? Object.keys(transformedObj["REVENUE"]).reduce(
        (sum: number, key: any) => {
          if (key?.includes("amount")) {
            sum += transformedObj["REVENUE"][key]
          }
          return sum
        },
        0,
      )
      : 0

    Object.keys(transformedObj).forEach((lineItem) => {
      const lineItemCurrent = Object.keys(transformedObj[lineItem]).reduce(
        (sum: number, key: any) => {
          if (key?.includes("amount")) {
            sum += transformedObj[lineItem][key]
          }
          return sum
        },
        0,
      )
      if (lineItem !== "REVENUE") {
        currentTotalExpenses += lineItemCurrent
      }
      transformedObj[lineItem]["-total_current"] = lineItemCurrent

      // Calculate percentage for current year total
      if (revenueTotal > 0) {
        const percentValue = (lineItemCurrent / revenueTotal) * 100
        transformedObj[lineItem]["-total_current_percent"] = Number.isNaN(
          percentValue,
        )
          ? 0
          : parseFloat(percentValue.toFixed(1))
      } else {
        transformedObj[lineItem]["-total_current_percent"] = 0
      }
    })

    const currentNetExpenses =
      transformedObj["REVENUE"]["-total_current"] - currentTotalExpenses
    footer["exp"]["-total_current"] = currentTotalExpenses.toFixed(0)
    footer["net"]["-total_current"] = currentNetExpenses.toFixed(0)

    // Calculate percentage for footer
    if (revenueTotal > 0) {
      const expPercent = (currentTotalExpenses / revenueTotal) * 100
      const netPercent = (currentNetExpenses / revenueTotal) * 100
      footer["exp"]["-total_current_percent"] = expPercent.toFixed(1)
      footer["net"]["-total_current_percent"] = netPercent.toFixed(1)
    } else {
      footer["exp"]["-total_current_percent"] = "0.0"
      footer["net"]["-total_current_percent"] = "0.0"
    }

    // Add previous annaualised data
    const range = data?.Previous_Annualized?.YearRange?.split(" - ")
    configObj.headers.startMonth = strFormat(range?.[0]?.slice(0, 3))
    configObj.headers.endMonth = strFormat(range?.[1]?.slice(0, 3))

    const refObj = data?.Previous_Annualized?.line_Items
    let expAmountTotal = 0
    let netAmountTotal = parseInt(refObj["REVENUE"]?.average || "0")
    let expPercentTotal = 0
    let netPercentTotal = 100
    let netAnnualAmount = parseInt(refObj["REVENUE"]?.annualized || "0")
    let expAnnualAmount = 0

    Object.keys(refObj).forEach((key: string) => {
      // const objKey = strFormat(key.toLowerCase())
      transformedObj[key]["-budget_amount"] = refObj?.[key]?.average
      transformedObj[key]["-budget_percent"] = refObj?.[key]?.percent
      transformedObj[key]["-annual_amount"] = refObj?.[key]?.annualized
      if (key !== "REVENUE") {
        expAmountTotal = expAmountTotal + refObj?.[key]?.average
        expPercentTotal = expPercentTotal + refObj?.[key]?.percent
        expAnnualAmount = expAnnualAmount + refObj?.[key]?.annualized

        netAmountTotal = netAmountTotal - refObj?.[key]?.average
        netPercentTotal = netPercentTotal - refObj?.[key]?.percent
        netAnnualAmount = netAnnualAmount - refObj?.[key]?.annualized
      }
    })

    footer["exp"]["-budget_amount"] = expAmountTotal.toFixed(0)
    footer["exp"]["-budget_percent"] = expPercentTotal.toFixed(1)
    footer["exp"]["-annual_amount"] = expAnnualAmount.toFixed(0)

    footer["net"]["-budget_amount"] = netAmountTotal.toFixed(0)
    footer["net"]["-budget_percent"] = netPercentTotal.toFixed(1)
    footer["net"]["-annual_amount"] = netAnnualAmount.toFixed(0)

    // Make the data flat
    configObj.transformedData = Object.keys(transformedObj).map((key) => {
      return {
        line_item: key,
        ...transformedObj[key],
      }
    })
    configObj.aggregation = Object.keys(footer).map((key) => {
      return {
        ...footer[key],
      }
    })
  }

  return configObj
}
